export default __webpack_public_path__ + "static/media/s_gts7.6ef8ef69.jpg";